<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<h1>Foreword</h1>
<p>Sometimes I look back at my life, and it seems like a long, hard road along which I have travelled willy nilly. A strange thing to say since I am regarded as a strong-minded woman. My weakness has always been that I cared about every person I ever met, friend, acquaintance, stranger—I cared. Unfortunately, that caring was often misunderstood and mistaken for weakness or stupidity or blindness. Like King Charles II, I believe in giving people enough rope—and enough space. Being a lover of freedom I tried not to impose my will upon other people but to let them think for themselves.</p>
<p>Calamity seems to be attracted towards me. I’ve searched for reasons why and many answers present themselves to my mind—all of which are only partially acceptable.</p>
<p>There has been so much sorrow in my life—for so many different reasons—and it all seems so pointless and futile now.</p>
<p>I have come a long, long way from that wide eyed and wondering child I used to be. And yet that child is still me. I still look at the grass and trees and the flowers and see so much beauty. Only my view is tinged with sadness now. Sadness for things gone, opportunities missed, people I have loved and lost. Most of all my beautiful, adored ANDROMEDA—who was my young self-incarnate and who saw merely 22 brief summers on this earth.</p>
<p>This is for her—my ANDROMEDA—my beloved girl who will live for ever in my memory.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?49bc9653